import React from 'react';
import { Link } from 'react-router-dom';
import ServiceCard from '../components/ServiceCard';

const SERVICIOS = [
  { icono: '🧠', titulo: 'Trauma y PTSD', descripcion: 'Trabajamos con terapia EMDR, somatic experiencing y TCC para abordar el trauma de forma segura y efectiva, respetando el ritmo de cada persona.' },
  { icono: '💆', titulo: 'Ansiedad y Estrés', descripcion: 'Identificamos los patrones que alimentan la ansiedad y desarrollamos estrategias personalizadas de regulación emocional y manejo del estrés.' },
  { icono: '🌱', titulo: 'Duelo y Pérdidas', descripcion: 'Acompañamos el duelo por pérdidas de seres queridos, relaciones, trabajo o identidad con presencia compasiva y sin juicio.' },
  { icono: '🤝', titulo: 'Terapia de Pareja', descripcion: 'Espacios seguros para reconstruir la comunicación, sanar heridas relacionales y fortalecer el vínculo.' },
  { icono: '🪞', titulo: 'Autoestima e Identidad', descripcion: 'Exploramos la relación contigo mismo, trabajando creencias limitantes y construyendo una narrativa personal más compasiva.' },
  { icono: '🌙', titulo: 'Trastornos del Sueño', descripcion: 'Abordaje psicológico del insomnio, pesadillas recurrentes y alteraciones del sueño asociadas al estrés o trauma.' },
];

export default function Servicios() {
  return (
    <div className="pt-24">
      {/* Header */}
      <section className="py-20 bg-teal-950 text-white">
        <div className="max-w-6xl mx-auto px-6">
          <p className="text-teal-400 text-xs uppercase tracking-widest mb-4">Psicología especializada</p>
          <h1 className="font-display text-5xl md:text-6xl mb-6">Nuestros servicios</h1>
          <p className="text-teal-200 text-lg max-w-xl leading-relaxed">
            Ofrecemos atención psicológica basada en evidencia, adaptada a la singularidad de cada persona.
          </p>
        </div>
      </section>

      {/* Grid */}
      <section className="py-24 bg-stone-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-6">
            {SERVICIOS.map(s => <ServiceCard key={s.titulo} {...s} />)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-white text-center border-t border-stone-100">
        <div className="max-w-xl mx-auto px-6">
          <h2 className="font-display text-3xl text-stone-800 mb-4">¿No sabes por dónde empezar?</h2>
          <p className="text-stone-500 text-sm mb-8">Escríbenos y te orientamos hacia el servicio más adecuado para ti.</p>
          <Link to="/contacto" className="btn-primary">Contáctanos</Link>
        </div>
      </section>
    </div>
  );
}